/*
 * Name       : volumeMapping.js
 * Create On  : Dec 27, 2022
 * Author     : Frank Post
 * Version    : n/a
 * Copyright  : 2022 GrayV (Sauce Industries, LLS)
 * Description: This class manages volume mapping for physical player types.
 */

const Mapping = {
    "05/08": [ 0,3,6,10,13,16,20,23,26,30,33,36,40,43,46,50,53,56,60,63,66,70,73,76,80,83,86,90,93,96,100 ],
    "06/00": [ 0,3,6,9,12,16,19,22,25,29,32,35,38,41,45,48,51,54,58,61,64,67,70,74,77,80,83,87,90,93,96,100 ],
    "Vortex86DX3": [ 0,3,6,9,12,16,19,22,25,29,32,35,38,41,45,48,51,54,58,61,64,67,70,74,77,80,83,87,90,93,96,100 ],
    "N2800": [ 0,2,3,4,5,6,7,8,9,10,11,12,13,14,15,17,18,19,20,21,22,23,24,25,26,27,28,29,30,31,32,33,34,35,36,37,38,39,40,41,42,43,44,45,46,47,48,50,51,52,53,54,55,56,57,58,59,60,61,62,63,64,65,66,67,68,69,70,71,72,73,74,75,76,77,78,79,80,81,83,84,85,86,87,88,89,90,91,92,93,94,95,96,97,98,99,100 ],
    "D425": [ 0,3,4,6,7,9,10,12,14,15,17,18,20,21,23,25,26,28,29,31,32,34,35,37,39,40,42,43,45,46,48,50,51,53,54,56,57,59,60,62,64,65,67,68,70,71,73,75,76,78,79,81,82,84,85,87,89,90,92,93,95,96,98,100 ],
    "D410": [ 0,3,4,6,7,9,10,12,14,15,17,18,20,21,23,25,26,28,29,31,32,34,35,37,39,40,42,43,45,46,48,50,51,53,54,56,57,59,60,62,64,65,67,68,70,71,73,75,76,78,79,81,82,84,85,87,89,90,92,93,95,96,98,100 ],
    "Default": [ 0,4,8,12,16,20,24,28,32,36,40,44,48,52,56,60,64,68,72,76,80,84,88,92,96,100 ]
};

export default class VolumeMapping {

    currentPlayerModel = "Default";
    
    constructor() {
       if (this instanceof VolumeMapping) {
            throw Error('A static class cannot be instantiated.');
       }
    }

    /**
     * Sets the current player model according to defined Mapping indexes
     * 
     * @param string playerModel - name of the player model 
     * @returns none
     */
    static setPlayerModel(playerModel) {
        try {
            for(var index in Mapping) {
                if (playerModel == index) {
                    this.currentPlayerModel = playerModel;
                    return;
                }
              }
        } catch(error) {
            console.log('error - unknown player model in VolumeMapping class - setting to default mapping');
        }
        this.currentPlayerModel = "Default";
    }

    /**
     * Returns the size (length) of the current player model Mapping array
     * 
     * @returns integer length of Mapping array
     */
    static getMappingSize() {
        return Mapping[this.currentPlayerModel].length;
    }

    /**
     * Return the current player model Mapping array
     * 
     * @returns array of the current player model mapping values
     */
    static getMappingArray() {
        return Mapping[this.currentPlayerModel];
    }
    
    /**
     * Map the requested volume level to the current player model mapping
     * 
     * @param integer volumeLevel - requested volume level to map
     * @returns integer mapped volume level
     */
    static getVolumeLevel(volumeLevel) {
        if (volumeLevel < 0) {
            return 0; // minimum volume level
        }
        if (volumeLevel >= this.getMappingSize()) {
            return 100; // maximum volume level
        }
        return Mapping[this.currentPlayerModel][volumeLevel];
    }

    /**
     * Return the index of the requested volume level to the current player model mapping
     * 
     * @param integer volumeLevel - requested volume level to index
     * @returns string index of the mapped volume level
     */
     static getVolumeLevelIndex(volumeLevel) {
        if (volumeLevel < 0) {
            return "0"; // minimum volume level
        }
        if (volumeLevel >= 100) {
            return (this.getMappingSize() - 1).toString(); // maximum volume level index
        }
        
        // get index of volume level
        const modelMapping = this.getMappingArray();
        for (const key in modelMapping) {
            if (modelMapping[key] >= volumeLevel) {
                return key;
            }
        }
        return "0"; // minimum volume level by default
    }
}